import type { FC } from 'react';

import PageFrame from 'src/components/common/PageFrame';

import LoginSelector from './components/LoginSelector';

const LoginPageMobile: FC = () => (
  <PageFrame>
    <LoginSelector />
  </PageFrame>
);

export default LoginPageMobile;
